var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10Z",
    fill: "#006EBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C10.5523 17 11 16.5523 11 16C11 15.4477 10.5523 15 10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17Z",
    fill: "#006EBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C11 22.5523 10.5523 23 10 23C9.44772 23 9 22.5523 9 22C9 21.4477 9.44772 21 10 21C10.5523 21 11 21.4477 11 22Z",
    fill: "#006EBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11H22C22.5523 11 23 10.5523 23 10C23 9.44772 22.5523 9 22 9H14Z",
    fill: "#006EBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16C13 15.4477 13.4477 15 14 15H22C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H14C13.4477 17 13 16.5523 13 16Z",
    fill: "#006EBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C13.4477 21 13 21.4477 13 22C13 22.5523 13.4477 23 14 23H22C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21H14Z",
    fill: "#006EBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C6.79086 2 5 3.79086 5 6V26C5 28.2091 6.79086 30 9 30H23C25.2091 30 27 28.2091 27 26V6C27 3.79086 25.2091 2 23 2H9ZM23 4H9C7.89543 4 7 4.89543 7 6V26C7 27.1046 7.89543 28 9 28H23C24.1046 28 25 27.1046 25 26V6C25 4.89543 24.1046 4 23 4Z",
    fill: "#006EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.5c51ac54a8de0097afb2957c95609e29.svg";
export { ForwardRef as ReactComponent };